export class AircraftModel {
  name: string;
}
